module.exports = __webpack_public_path__ + "img/gPanel.9c7d4f36.png";